import React from 'react'
import { Card, Tabs } from 'antd';
import ContactTab from '@/components/management/settings/ContactTab';
import LogoTab from '@/components/management/settings/LogoTab';
import GeneralTab from '@/components/management/settings/GeneralTab';
import FaviconTab from '@/components/management/settings/FaviconTab';

const { TabPane } = Tabs;
const ManagementSettings = () => {
  return (
    <Card>
      <Tabs defaultActiveKey="1" type="line">
        <TabPane tab="Contact" key="1">
          <ContactTab />
        </TabPane>
        <TabPane tab="Logo" key="2">
          <LogoTab />
        </TabPane>
        <TabPane tab="Favicon" key="3">
          <FaviconTab />
        </TabPane>
        <TabPane tab="General" key="4">
          <GeneralTab />
        </TabPane>
      </Tabs>


    </Card>
  )
}

export default ManagementSettings